import { Box, LinearProgress } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid/DataGrid';

import DatagridFooter from '../../Datagrid/DatagridFooter';
import DatagridNoRowsOverlay from '../../Datagrid/DatagridNoRowsOverlay';
import datagridStyles from '../../Datagrid/Datagrid.styles';
import { PAGE_SIZE_OPTIONS } from '../constants';
import { snapshotComparisonColumns } from '../columns';
import { SnapshotComparisonApplication } from '../types';
import pageStyles from '../styles';

/* eslint-disable no-unused-vars */
type SnapshotComparisonTableProps = {
  rows: SnapshotComparisonApplication[];
  total: number;
  loading: boolean;
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
};
/* eslint-enable no-unused-vars */

const SnapshotComparisonTable = ({
  rows,
  total,
  loading,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange
}: SnapshotComparisonTableProps) => {
  return (
    <Box sx={pageStyles.tableContainer}>
      <DataGrid
        sx={datagridStyles.datagrid}
        rows={rows}
        columns={snapshotComparisonColumns}
        getRowId={row => row.application_number}
        rowCount={total}
        page={page}
        pageSize={pageSize}
        pagination
        paginationMode='server'
        rowsPerPageOptions={PAGE_SIZE_OPTIONS}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        loading={loading}
        checkboxSelection={false}
        disableSelectionOnClick
        autoHeight={false}
        components={{
          LoadingOverlay: LinearProgress,
          Footer: DatagridFooter,
          NoRowsOverlay: DatagridNoRowsOverlay
        }}
      />
    </Box>
  );
};

export default SnapshotComparisonTable;
